import { REFINANCING_LIMITS } from "shared/CalculatorLimits";
import { getAmountField } from "web_myplann/Calculators/Forms/getAmountField";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { z } from "zod";

export const getRefinancingFormSchema = (t: TranslateFunction) => {
	const required = t(Resources.Form.Validations.required);

	return z.object({
		propertyPrice: getAmountField(t, {
			min: REFINANCING_LIMITS.propertyPriceMin,
			max: REFINANCING_LIMITS.propertyPriceMax,
		}),
		monthlyPayment: getAmountField(t, {
			max: REFINANCING_LIMITS.monthlyPaymentMax,
		}),
		interest: z
			.number({ required_error: required, invalid_type_error: required })
			.gt(0, t(Resources.Calculators.Validation.RatePositive))
			.max(
				REFINANCING_LIMITS.interestMax,
				t(Resources.Calculators.Validation.MaxRate, {
					rate: REFINANCING_LIMITS.interestMax,
				}),
			),
		years: z.number(),
		paidYears: z.number(),
	});
};
